import PermissionConfigurationDetailSection from '../../../sections/AdminDashboard/Configuration/PermissionConfigurationDetail';

const PermissionConfigurationDetail = () => <PermissionConfigurationDetailSection />;

export default PermissionConfigurationDetail;
